<div class="row">
  <div class="col-12 col-md-12">
    <section class="table_lis_data">
      <div id="header-detail" class="d-flex flex-row justify-content-between container-style">
        <div class="col-lg-2 col-md-3 col-sm-6 col-12">
          <form [formGroup]="formSettlement">
            <app-custom-select formControlName="conceptInvoicingId" [labelText]="'Concepto Facturación'"
              [list]="listConceptInvoicing" [required]="true">
            </app-custom-select>
          </form>
        </div>
      </div>
      <div class="pt-1">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 ">
          <app-custom-table [showRecover]="true" [showCheckbox]="true" [isMultipleSelect]="true" [data]="data"
            [headers]="headers" [checkBoxAction]="checkboxActions" [previousFilters]="filters"
            (onPageChange)="onPageChangeEmit($event)" (onFilterChange)="onFilterChangeEmit($event)"
            (onAction)="onAction($event)">
          </app-custom-table>
        </div>
      </div>
    </section>
  </div>
</div>